const styles = (theme) => ({
  actions: {
    background: 'white',
    position: 'absolute',
    top: 8,
    right: 10,
  },

  actionsButtonRoot: {
    height: 39,
    width: 39,
    borderRadius: theme.shape.borderRadius,
    color: '#A9B0B8',
    fill: 'currentColor',
  },
});

export default styles;
